export default "__VITE_ASSET__CfX$Sll___"